"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageGrid = void 0;
const pdfTheme_1 = require("../pdfTheme");
const ImageWithTitle_1 = require("./ImageWithTitle");
const COLUMN_SPACING = pdfTheme_1.pdfTheme.spacing.default;
class ImageGrid {
    constructor(imageGroups, columns = 3, availableWidth = pdfTheme_1.pdfTheme.page.width) {
        this.imageGroups = imageGroups;
        this.columns = columns;
        this.availableWidth = availableWidth;
        this.nodes = [];
    }
    exportContent() {
        const rows = [];
        const imageWidth = (this.availableWidth - (COLUMN_SPACING * (this.columns - 1))) / this.columns;
        Object.entries(this.imageGroups).sort((a, b) => a[0].localeCompare(b[0])).forEach(([group, imageReferences]) => {
            imageReferences.forEach((imageReference, i) => {
                const image = new ImageWithTitle_1.ImageWithTitle(group, imageReference, { pageBreak: 'none', width: imageWidth });
                this.nodes.push(image);
            });
        });
        this.nodes.forEach((node, i) => {
            var _a;
            if (i % this.columns === 0) {
                rows.push([]);
            }
            const content = node.exportContent();
            content.width = (100 / this.columns) + '%';
            (_a = rows[rows.length - 1]) === null || _a === void 0 ? void 0 : _a.push(content);
        });
        return {
            marginTop: 2,
            marginBottom: 2,
            stack: [
                ...rows.map((columnSet) => ({
                    columns: columnSet,
                    columnGap: COLUMN_SPACING,
                    marginBottom: 10
                }))
            ]
        };
    }
    exportStyles() {
        return {
            imageGridTitle: {
                fontSize: 15,
                bold: true,
                marginBottom: 6
            }
        };
    }
}
exports.ImageGrid = ImageGrid;
//# sourceMappingURL=ImageGrid.js.map